import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=0efb1678&scoped=true"
import script from "./studentInfo.vue?vue&type=script&lang=js"
export * from "./studentInfo.vue?vue&type=script&lang=js"
import style0 from "./studentInfo.vue?vue&type=style&index=0&id=0efb1678&prod&lang=scss"
import style1 from "./studentInfo.vue?vue&type=style&index=1&id=0efb1678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb1678",
  null
  
)

export default component.exports